<template lang="pug">
  .dialog
    .view-password-validation-delete-dialog
      el-dialog(
        :title="dialogData.dialogTitle"
        center
        :visible.sync='isViewPasswordValidationDelete'
        width='567px'
        :before-close='hideViewPasswordValidationDeleteDialog'
        :show-close="true"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      )
        PasswordValidationDelete

    .view-password-validation-delete-dialog
      el-dialog(
        v-if="isManageSnoozeNotificationsDialogVisible"
        :title="$t('dialog.configure_snooze_notifications')"
        center
        :visible.sync='isManageSnoozeNotificationsDialogVisible'
        width='1180px'
        :before-close='hideManageSnoozeNotificationsDialog'
        :show-close="true"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      )
        ManageSnoozeNotifications

    .view-password-validation-delete-dialog
      el-dialog(
        v-if="isEditSnoozeNotificationDialogVisible"
        :title="$t('dialog.edit_snooze_notification')"
        center
        :visible.sync='isEditSnoozeNotificationDialogVisible'
        width='480px'
        :before-close='hideEditSnoozeNotificationDialog'
        :show-close="true"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      )
        EditSnoozeNotification

    .view-password-validation-delete-dialog
      el-dialog(
        v-if="isAddSnoozeNotificationDialogVisible"
        :title="$t('dialog.add_snooze_notification')"
        center
        :visible.sync='isAddSnoozeNotificationDialogVisible'
        width='480px'
        :before-close='hideAddSnoozeNotificationDialog'
        :show-close="true"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      )
        AddSnoozeNotification

    .add-site-dialog
      el-dialog.custom-map-dialog(
        v-if="isAddSiteDialogVisible"
        :title="$t('dialog.add_new_site')"
        center
        :visible.sync='isAddSiteDialogVisible'
        width='940px'
        :before-close='hideAddSiteDialog'
        :show-close="true"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      )
        AddSite

    .edit-site-dialog
      el-dialog.custom-map-dialog(
        v-if="isEditSiteDialogVisible"
        :title="$t('dialog.edit_site')"
        center
        :visible.sync='isEditSiteDialogVisible'
        width='940px'
        :before-close='hideEditSiteDialog'
        :show-close="true"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      )
        EditSite

    .add-user-dialog
      el-dialog.custom-map-dialog(
        v-if="isAddUserDialogVisible"
        :title="$t('dialog.add_new_user')"
        center
        :visible.sync='isAddUserDialogVisible'
        width='800px'
        :before-close='hideAddUserDialog'
        :show-close="true"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      )
        AddUser

    .edit-user-dialog
      el-dialog.custom-map-dialog(
        v-if="isEditUserDialogVisible"
        :title="$t('dialog.edit_user')"
        center
        :visible.sync='isEditUserDialogVisible'
        width='800px'
        :before-close='hideEditUserDialog'
        :show-close="true"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      )
        EditUser

    .add-field-dialog
      el-dialog.custom-map-dialog(
        v-if="isAddFieldDialogVisible"
        :title="$t('dialog.add_new_field')"
        center
        :visible.sync='isAddFieldDialogVisible'
        width='1350px'
        :before-close='hideAddFieldDialog'
        :show-close="true"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      )
        AddField

    .edit-field-dialog
      el-dialog.custom-map-dialog(
        v-if="isEditFieldDialogVisible"
        :title="$t('dialog.edit_field')"
        center
        :visible.sync='isEditFieldDialogVisible'
        width='1350px'
        :before-close='hideEditFieldDialog'
        :show-close="true"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      )
        EditField

    .edit-field-dialog
      el-dialog.custom-map-dialog(
        v-if="isEditFieldInfoSettingsDialogVisible"
        :title="$t('dialog.edit_field_info_setting')"
        center
        :visible.sync='isEditFieldInfoSettingsDialogVisible'
        width='880px'
        :before-close='hideEditFieldInfoSettingsDialog'
        :show-close="true"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      )
        EditFieldInfoSettings

    .edit-transmitter-dialog
      el-dialog.custom-map-dialog(
        v-if="isEditTransmitterDialogVisible"
        :visible.sync='isEditTransmitterDialogVisible'
        width='940px'
        :before-close='hideEditTransmitterDialog'
        :show-close="true"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      )
        template(#title)
          .dialog-title-with-icon
            img.dialog-title-icon(src="@assets/actions/transmitter.svg")
            span {{ transmitter ? transmitter.name : $t('dialog.edit_transmitter') }}
        EditTransmitter

    .edit-transmitter-dialog
      el-dialog.custom-map-dialog(
        v-if="isEditTransmitterConfigDialogVisible"
        :visible.sync='isEditTransmitterConfigDialogVisible'
        width='940px'
        :before-close='hideEditTransmitterConfigDialog'
        :show-close="true"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      )
        template(#title)
          .dialog-title-with-icon
            img.dialog-title-icon(src="@assets/actions/transmitter.svg")
            span {{ transmitter ? transmitter.name : $t('dialog.edit_transmitter_config') }}
        EditTransmitterConfig

    .edit-transmitter-dialog
      el-dialog.custom-map-dialog(
        v-if="isViewStatusDialogVisible"
        :visible.sync='isViewStatusDialogVisible'
        width='1500px'
        :before-close='hideViewStatusDialog'
        :show-close="true"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      )
        template(#title)
          .dialog-title-with-icon
            img.dialog-title-icon(src="@assets/actions/transmitter.svg")
            span {{ transmitter ? transmitter.name : $t('dialog.view_status') }}
        ViewStatus

    .manage-sensors-dialog
      el-dialog.custom-map-dialog(
        v-if="isEditSensorDialogVisible"
        :title="$t('dialog.edit_sensor')"
        center
        :visible.sync='isEditSensorDialogVisible'
        width='940px'
        :before-close='hideEditSensorDialog'
        :show-close="true"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      )
        EditSensor

    .manage-sensors-dialog
      el-dialog.custom-map-dialog(
        v-if="isViewSensorDialogVisible"
        :title="$t('dialog.view_sensor')"
        center
        :visible.sync='isViewSensorDialogVisible'
        width='1500px'
        :before-close='hideViewSensorDialog'
        :show-close="true"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      )
        ViewSensor

    .transmitter-sensors-dialog
      el-dialog.custom-map-dialog(
        v-if="isTransmitterSensorsDialogVisible"
        :visible.sync='isTransmitterSensorsDialogVisible'
        width='1200px'
        :before-close='hideTransmitterSensorsDialog'
        :show-close="true"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
      )
        template(#title)
          .dialog-title-with-icon
            img.dialog-title-icon(src="@assets/actions/transmitter.svg")
            span {{ transmitter ? transmitter.name : $t('dialog.view_sensors') }}
        TransmitterSensors

</template>

<script>
import { bus } from "@src/main";
import { mapMutations, mapState } from "vuex";
import AddUser from "./templates/AddUser.vue";
import EditUser from "./templates/EditUser.vue";
import AddSite from "./templates/AddSite.vue";
import EditSite from "./templates/EditSite.vue";
import AddField from "./templates/AddField.vue";
import EditField from "./templates/EditField.vue";
import EditFieldInfoSettings from "./templates/EditFieldInfoSettings.vue";
import EditTransmitter from "./templates/EditTransmitter.vue";
import EditTransmitterConfig from "./templates/EditTransmitterConfig.vue"; 
import ViewStatus from "./templates/ViewStatus.vue";
import EditSensor from "./templates/EditSensor.vue";
import ViewSensor from "./templates/ViewSensor.vue";
import ManageSnoozeNotifications from "./templates/ManageSnoozeNotifications.vue";
import AddSnoozeNotification from "./templates/AddSnoozeNotification.vue";
import EditSnoozeNotification from "./templates/EditSnoozeNotification.vue";
import PasswordValidationDelete from "./templates/PasswordValidationDelete.vue";
import TransmitterSensors from "./templates/TransmitterSensors.vue";

export default {
  name: "Dialogs",
  components: {
    AddUser,
    EditUser,
    AddSite,
    EditSite,
    AddField,
    EditField,
    EditFieldInfoSettings,
    EditTransmitter,
    EditTransmitterConfig,
    ViewStatus,
    EditSensor,
    ViewSensor,
    ManageSnoozeNotifications,
    AddSnoozeNotification,
    EditSnoozeNotification,
    PasswordValidationDelete,
    TransmitterSensors,
  },

  computed: {
    ...mapState("dialog", [
      "isAddSiteDialogVisible",
      "isEditSiteDialogVisible",
      "isViewUserDialogVisible",
      "isAddNewUserDialogVisible",
      "isViewPasswordValidationDelete",
      "isManageSnoozeNotificationsDialogVisible",
      "isAddSnoozeNotificationDialogVisible",
      "isEditSnoozeNotificationDialogVisible",
      "isAddUserDialogVisible",
      "isEditUserDialogVisible",
      "isAddFieldDialogVisible",
      "isEditFieldDialogVisible",
      "isEditFieldInfoSettingsDialogVisible",
      "isEditTransmitterDialogVisible",
      "isEditTransmitterConfigDialogVisible",
      "isViewStatusDialogVisible",
      "isEditSensorDialogVisible",
      "isViewSensorDialogVisible",
      "isTransmitterSensorsDialogVisible"
    ]),

    ...mapState("passwordValidationDelete", ["dataToDelete", "dialogData"]),
    ...mapState("auth", ["user"]),
    ...mapState("transmitter", ["transmitter"])
  },

  methods: {
    ...mapMutations("dialog", [
      "hideAddSiteDialog",
      "hideEditSiteDialog",
      "hideViewUserDialog",
      "hideAddNewUserDialog",
      "hideEditUserDialog",
      "hideViewPasswordValidationDeleteDialog",
      "hideManageSnoozeNotificationsDialog",
      "hideAddSnoozeNotificationDialog",
      "hideEditSnoozeNotificationDialog",
      "hideAddUserDialog",
      "hideEditUserDialog",
      "hideAddFieldDialog",
      "hideEditFieldDialog",
      "hideEditFieldInfoSettingsDialog",
      "hideEditTransmitterDialog",
      "hideEditTransmitterConfigDialog",
      "hideViewStatusDialog",
      "hideEditSensorDialog",
      "hideViewSensorDialog",
      "hideTransmitterSensorsDialog"
    ]),

    createMap() {
      bus.$emit("create-map");
    },
  },
};
</script>

<style lang="scss">
.dialog-title-with-icon {
  display: flex;
  align-items: center;
  gap: 8px;

  .dialog-title-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  span {
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
  }
}
</style>
